"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoverDetailsSummary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _summaryKeyValuePair = require("../SummaryKeyValuePair/summaryKeyValuePair");
var _brandContext = require("../../../contextProviders/brandContext");
var _selectors = require("../../../store/quote/selectors");
var _handlers = require("./handlers");
var _steps = require("../../../constants/app/steps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CoverDetailsSummary = exports.CoverDetailsSummary = function CoverDetailsSummary(_ref) {
  var pet = _ref.pet;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext$activeBra = _useContext.activeBrandContext,
    _useContext$activeBra2 = _useContext$activeBra.steps,
    _useContext$activeBra3 = _useContext$activeBra2.summary.petSummary,
    allowEdit = _useContext$activeBra3.allowEdit,
    _useContext$activeBra4 = _useContext$activeBra3.coverDetailsSection,
    infoCoverSummaryLabels = _useContext$activeBra4.labels,
    keyInclusionsLabels = _useContext$activeBra4.keyInclusionsLabels,
    collectionFeeToolTip = _useContext$activeBra4.collectionFeeToolTip,
    coverBreakdown = _useContext$activeBra4.coverBreakdown,
    StepDefinitions = _useContext$activeBra2.StepDefinitions,
    productDefinitions = _useContext$activeBra.productDefinitions,
    groupedProductNames = _useContext$activeBra.tableLayoutConfiguration.groupedProductNames;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    savedQuote = _useSelector.quote;
  var _pet$selectedQuote = pet.selectedQuote,
    planNumber = _pet$selectedQuote.planNumber,
    totalPremiumAmount = _pet$selectedQuote.totalPremiumAmount;
  var productName = groupedProductNames && groupedProductNames[pet === null || pet === void 0 ? void 0 : pet.selectedQuote.productName] ? groupedProductNames[pet === null || pet === void 0 ? void 0 : pet.selectedQuote.productName] : pet === null || pet === void 0 ? void 0 : pet.selectedQuote.productName;
  var getProduct = function getProduct() {
    var product;
    Object.values(productDefinitions).forEach(function (plans) {
      // eslint-disable-next-line array-callback-return
      Object.entries(plans).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        if ("Plan_".concat(planNumber) === key) product = value;
      });
    });
    return product;
  };
  var _getProduct = getProduct(),
    dental = _getProduct.dental,
    routineCare = _getProduct.routineCare,
    externalName = _getProduct.externalName,
    limits = _getProduct.limits;
  var handleEdit = function handleEdit() {
    navigate("/".concat(StepDefinitions.find(function (step) {
      return step.id === _steps.StepIndex.coverOptions;
    }).url));
  };
  var formatLabel = function formatLabel(key, label) {
    var _keyInclusionsLabels$, _keyInclusionsLabels$2;
    var routineCareValue = (_keyInclusionsLabels$ = keyInclusionsLabels === null || keyInclusionsLabels === void 0 ? void 0 : keyInclusionsLabels.routineCare) !== null && _keyInclusionsLabels$ !== void 0 ? _keyInclusionsLabels$ : '';
    var dentalValue = (_keyInclusionsLabels$2 = keyInclusionsLabels === null || keyInclusionsLabels === void 0 ? void 0 : keyInclusionsLabels.dental) !== null && _keyInclusionsLabels$2 !== void 0 ? _keyInclusionsLabels$2 : '';
    if (key === 'excess') {
      return (0, _handlers.formatExcessContent)({
        coverBreakdown: coverBreakdown,
        productName: productName,
        label: label,
        pet: pet,
        routineCare: routineCare,
        dental: dental,
        routineCareValue: routineCareValue,
        dentalValue: dentalValue
      });
    }
    if (key === 'basePremium') {
      return label(pet === null || pet === void 0 ? void 0 : pet.selectedQuote.paymentFrequencyCode);
    }
    if (key === 'overallAnnualLimit') {
      return "".concat(coverBreakdown === null || coverBreakdown === void 0 ? void 0 : coverBreakdown.overallAnnualLimit, ": ");
    }
    if (key === 'annualExcess') {
      return "".concat(coverBreakdown === null || coverBreakdown === void 0 ? void 0 : coverBreakdown.annualExcess, ": ");
    }
    if (key === 'benefitPercentage') {
      return "".concat(coverBreakdown === null || coverBreakdown === void 0 ? void 0 : coverBreakdown.benefitPercentage, ": ");
    }
    if (key === 'dental') {
      return "".concat(keyInclusionsLabels === null || keyInclusionsLabels === void 0 ? void 0 : keyInclusionsLabels.dental, ": ");
    }
    if (key === 'routineCare') {
      return "".concat(keyInclusionsLabels === null || keyInclusionsLabels === void 0 ? void 0 : keyInclusionsLabels.routineCare, ": ");
    }
    return null;
  };
  var formatValue = function formatValue(key) {
    var _pet$selectedQuote$to, _pet$selectedQuote2, _pet$selectedQuote$to2, _pet$selectedQuote3, _pet$selectedQuote$to3, _pet$selectedQuote4, _limits$annualLimit, _pet$selectedQuote$ex, _pet$selectedQuote5, _pet$selectedQuote$le, _pet$selectedQuote6, _pet$selectedQuote$ke;
    switch (key) {
      case 'basePremium':
        return ((_pet$selectedQuote$to = pet === null || pet === void 0 || (_pet$selectedQuote2 = pet.selectedQuote) === null || _pet$selectedQuote2 === void 0 ? void 0 : _pet$selectedQuote2.totalBasePremium) !== null && _pet$selectedQuote$to !== void 0 ? _pet$selectedQuote$to : 0) + ((_pet$selectedQuote$to2 = pet === null || pet === void 0 || (_pet$selectedQuote3 = pet.selectedQuote) === null || _pet$selectedQuote3 === void 0 ? void 0 : _pet$selectedQuote3.totalOtherBaseLoading) !== null && _pet$selectedQuote$to2 !== void 0 ? _pet$selectedQuote$to2 : 0);
      case 'discounts':
        return (_pet$selectedQuote$to3 = pet === null || pet === void 0 || (_pet$selectedQuote4 = pet.selectedQuote) === null || _pet$selectedQuote4 === void 0 ? void 0 : _pet$selectedQuote4.totalLessDiscount) !== null && _pet$selectedQuote$to3 !== void 0 ? _pet$selectedQuote$to3 : 0;
      case 'excess':
        return ' ';
      case 'overallAnnualLimit':
        return limits === null || limits === void 0 || (_limits$annualLimit = limits.annualLimit) === null || _limits$annualLimit === void 0 ? void 0 : _limits$annualLimit.displayValue;
      case 'annualExcess':
        return "$".concat((_pet$selectedQuote$ex = pet === null || pet === void 0 || (_pet$selectedQuote5 = pet.selectedQuote) === null || _pet$selectedQuote5 === void 0 ? void 0 : _pet$selectedQuote5.excess) !== null && _pet$selectedQuote$ex !== void 0 ? _pet$selectedQuote$ex : 0);
      case 'benefitPercentage':
        return "".concat((_pet$selectedQuote$le = pet === null || pet === void 0 || (_pet$selectedQuote6 = pet.selectedQuote) === null || _pet$selectedQuote6 === void 0 ? void 0 : _pet$selectedQuote6.levelOfCover) !== null && _pet$selectedQuote$le !== void 0 ? _pet$selectedQuote$le : 0, "%");
      case 'dental':
        return "".concat(dental ? 'Selected' : 'Not selected');
      case 'routineCare':
        return "".concat(routineCare ? 'Selected' : 'Not selected');
      default:
        return (_pet$selectedQuote$ke = pet === null || pet === void 0 ? void 0 : pet.selectedQuote[key]) !== null && _pet$selectedQuote$ke !== void 0 ? _pet$selectedQuote$ke : savedQuote[key];
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "border-dashed"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "summaryKeyValuePair"
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: "labelText"
  }, "Cover details"), allowEdit && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button text_only value editBtn",
    onClick: function onClick() {
      return handleEdit(pet);
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "pencil"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Edit"))), coverBreakdown && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "summaryKeyValuePair"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, productName, " cover: ")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "coverBreakdown"
  }, Object.entries(_objectSpread(_objectSpread({}, coverBreakdown !== null && coverBreakdown !== void 0 ? coverBreakdown : {}), keyInclusionsLabels !== null && keyInclusionsLabels !== void 0 ? keyInclusionsLabels : {})).map(function (_ref4) {
    var _formatLabel;
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      label = _ref5[1];
    var formattedValue = formatValue(key);
    var formattedLabel = (_formatLabel = formatLabel(key, label)) !== null && _formatLabel !== void 0 ? _formatLabel : label;
    if (!formattedValue) {
      return null;
    }
    return formattedLabel !== '' && /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
      key: key,
      label: formattedLabel,
      labelTooltip: null,
      value: formattedValue
    });
  }))), Object.entries(infoCoverSummaryLabels).map(function (_ref6) {
    var _formatLabel2;
    var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      label = _ref7[1];
    var formattedValue = formatValue(key);
    var formattedLabel = (_formatLabel2 = formatLabel(key, label)) !== null && _formatLabel2 !== void 0 ? _formatLabel2 : label;
    if (!formattedValue) {
      return null;
    }
    return formattedLabel !== '' && /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
      key: key,
      label: formattedLabel,
      labelTooltip: key === 'totalCollectionFee' ? collectionFeeToolTip : null,
      value: !Number.isNaN(+formattedValue) && key !== 'excess' ? (0, _helpers.FormatAsCurrency)(formattedValue) : formattedValue
    });
  }), /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "Subtotal",
    label: "Subtotal",
    value: !Number.isNaN(+totalPremiumAmount) ? (0, _helpers.FormatAsCurrency)(totalPremiumAmount) : totalPremiumAmount,
    isTotal: true
  }));
};
CoverDetailsSummary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pet: _propTypes["default"].any
};